import { Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeHtml } from '@angular/platform-browser';
import { MessageService } from 'primeng/api'; import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { GoogleGalleryService } from 'src/app/services/google-gallery.service';
import { MenuItem } from 'primeng/api';
import { of } from 'rxjs';
import { Observable, forkJoin, map } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-google-gallery',
  templateUrl: './google-gallery.component.html',
  styleUrls: ['./google-gallery.component.scss'],
  providers: [MessageService]
})
export class GoogleGalleryComponent implements OnInit, OnChanges {

  @Input() showContent = true;
  @Input() isFeed = false;
  @Input() feedTmp = false;
  @Input() showAutoPublish = false;
  @Input() enablePanelAdjustment = false;

  @Input() selectedItems: any[] = [];
  @Output() selectedItemsChange = new EventEmitter<any[]>();

  isSelected(item: any): boolean {
    return this.selectedItems.some(i => i.id === item.id);
  }

  isItemSelected(item: any): boolean {
    return this.selectedItems.some(i => i.id === item.id);
  }

  toggleSelection(item: any): void {
    const idx = this.selectedItems.findIndex(i => i.id === item.id);
    let newSelected: any[];
    if (idx >= 0) {
      newSelected = [
        ...this.selectedItems.slice(0, idx),
        ...this.selectedItems.slice(idx + 1)
      ];
    } else {
      newSelected = [...this.selectedItems, item];
    }
    this.selectedItemsChange.emit(newSelected);
  }

  showDta: boolean = false;

  @Input() showConectAccount = false;
  @Output() showConectAccountChange = new EventEmitter<boolean>();

  @Input() selectedGoogleAccountId?: string;
  @Output() selectedGoogleAccountIdChange = new EventEmitter<string>();

  @Input() selectedChannelId?: string;
  @Output() selectedChannelIdChange = new EventEmitter<string>();
  onChannelChange(channelId: string) {
    this.selectedChannelId = channelId;
    this.selectedChannelIdChange.emit(channelId);
    this.updateTabs(); // Atualiza abas conforme seleção
  }

  @Output() mediaResults = new EventEmitter<any[]>();

  @Input() autoPublish = false; // recebe valor inicial (se o pai quiser controlar)
  @Output() autoPublishChange = new EventEmitter<boolean>(); // notifica mudanças para o pai

  public hasChannels = false;
  // Sempre que mudar o valor do switch:
  onToggleAutoPublish(newValue: boolean) {
    this.autoPublish = newValue;
    this.autoPublishChange.emit(newValue); // notifica o pai
  }

  public tabs: MenuItem[] = [];
  public activeTab: MenuItem = this.tabs[0];

  mediaTypeOptions = [
    { label: 'Vídeo', value: 'video' },
    { label: 'Short', value: 'short' }
  ];

  googleAccountsOptions: any[] = [];
  displayAguarde = false; // Para loading spinner (se quiser)

  public loadingChannels = false;


  constructor(
    private google: GoogleGalleryService,
    private sanitizer: DomSanitizer,
    private errorHandler: ErrorHandlerService,
    private messageService: MessageService
  ) { }

  private updateTabs() {
    // Mantenha a label da aba ativa anterior, se possível
    const currentLabel = this.activeTab?.label;

    this.tabs = [
      { label: 'Hashtag' },
      { label: 'Canal' },
      { label: 'Playlist' },
      { label: 'Mídias', disabled: !this.hasChannels },
      { label: 'Curtidos', disabled: !this.hasChannels },
    ];

    // Procura por uma tab igual à ativa anterior, senão seta como a primeira
    const found = this.tabs.find(tab => tab.label === currentLabel && !tab.disabled);
    this.activeTab = found ?? this.tabs.find(tab => !tab.disabled) ?? this.tabs[0];
  }


  ngOnInit() {
    this.selectedGoogleAccountId = undefined;
    this.selectedChannelId = undefined;
    this.youtubeChannelsOptions = [];
    this.hasChannels = false;
    this.updateTabs();

    // "Filtrar por tipo" vazio significa "sem filtro" (aceita os dois) pro
    // fetch dentro deste componente (ver !selectedXMediaTypes.length nos
    // métodos de busca), mas feed.component.ts::doCreateFeed() só faz
    // `.join(',')` — um array vazio virava media_type: '' na criação do
    // feed, e o backend rejeita isso com 422 ("The media type field is
    // required."). Mesmo padrão que o Instagram já usa (initInstagram()):
    // pré-seleciona todos os tipos, então "Todos" nunca é "nenhum".
    const allMediaTypes = this.mediaTypeOptions.map(o => o.value);
    this.selectedHashtagMediaTypes = [...allMediaTypes];
    this.selectedMediaTypes = [...allMediaTypes];
    this.selectedChannelMediaTypes = [...allMediaTypes];

    this.loadGoogleAccounts();

  }

  getMainText(): string {
    if (this.showConectAccount && !this.displayAguarde) {
      return 'Conecte uma conta do Google para começar';
    }
    if (!this.showConectAccount && !this.displayAguarde) {
      return 'Selecione uma conta';
    }
    // Adicione outras condições se necessário...
    return '';
  }

  loadGoogleAccounts() {
    this.displayAguarde = true;
    this.google.getAccounts().subscribe({
      next: (accounts) => {
        this.googleAccountsOptions = accounts.map((a: any) => ({
          label: a.name || a.username || a.email,
          value: a.id,
          picture: a.picture || 'assets/avatar-placeholder.png',
          email: a.email
        }));
        // Seleciona automaticamente a primeira conta se nenhuma estiver selecionada
        if (this.googleAccountsOptions.length && !this.selectedGoogleAccountId) {
          //this.selectedGoogleAccountId = this.googleAccountsOptions[0].value;
          this.showConectAccount = false;
        } else if (!this.googleAccountsOptions.length) {
          this.showConectAccount = true;
        }

        if (!this.showConectAccount) {
          this.googleAccountsOptions.push({
            id: null,
            label: 'Adicionar uma conta',
            value: 'add_account',
            picture: 'pi pi-plus'
          });
        }

        this.showConectAccountChange.emit(this.showConectAccount);
        this.displayAguarde = false;
      },
      error: () => {
        this.displayAguarde = false;
        this.showConectAccount = true;
        this.showConectAccountChange.emit(this.showConectAccount);
      }
    });
  }

  @Output() connectGoogle = new EventEmitter<void>();

  conectGoogle() {
    this.connectGoogle.emit();
  }


  youtubeChannelsOptions: any[] = [];

  onSelectGoogleAccount(accountId: string) {
    if (accountId === 'add_account') {
      this.conectGoogle();
      return;
    }

    this.selectedGoogleAccountId = accountId;
    this.selectedGoogleAccountIdChange.emit(accountId);
    this.selectedChannelId = undefined;
    this.loadingChannels = true;

    this.google.getYoutubeChannels(accountId).subscribe({
      next: (channels) => {
        this.youtubeChannelsOptions = channels.map((c: any) => ({
          label: c.snippet?.title || c.id,
          value: c.id,
          picture: c.snippet?.thumbnails?.default?.url,
          description: c.snippet?.description
        }));
        this.hasChannels = !!this.youtubeChannelsOptions.length;
        this.updateTabs(); // Atualiza as tabs com disabled correto
        this.loadingChannels = false;
        if (!this.hasChannels) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Nenhum canal encontrado',
            detail: 'Você não possui canais neste Google.'
          });
        }
      },
      error: (error) => {
        this.youtubeChannelsOptions = [];
        this.hasChannels = false;
        this.updateTabs();
        this.loadingChannels = false;
        this.errorHandler.handle(error, 'Falha ao buscar canais do Google.');
      }
    });
  }


  rawMedia: any[] = [];
  public media: any[] = [];
  public hashtag = '';
  public targetChannel = '';
  public selectedMediaTypes: string[] = [];
  public selectedHashtagMediaTypes: string[] = [];
  public hasMoreMedia = false;
  public maxDescriptionLength = 100;

  // Troca abas
  onTabChange(tab: any) {
    this.activeTab = tab;
  }

  // Filtro para mídia própria
  applyUserMediaFilter() {
    this.media = this.rawMedia.filter(item =>
      !this.selectedMediaTypes.length || this.selectedMediaTypes.includes(item.type)
    );

    /////////////////////
    // aproveita o mesmo model que você já usa nessas três buscas
    const types: string[] =
      (this.getActiveMediaTypesModel && this.getActiveMediaTypesModel.length)
        ? this.getActiveMediaTypesModel
        : (this.selectedMediaTypes && this.selectedMediaTypes.length)
          ? this.selectedMediaTypes
          : [];

    this.media = (this.rawMedia || []).filter((item: any) => {
      const passType = types.length === 0 || types.includes(item.type);
      const passDesc = this.matchesText(item);
      return passType && passDesc;
    });
  }
  // Filtro para hashtag
  applyHashtagFilter() {
    // Só exibe os tipos selecionados
    this.media = this.rawMedia.filter(item =>
      !this.selectedHashtagMediaTypes.length || this.selectedHashtagMediaTypes.includes(item.type)
    );

    //////////////////////////
    const types: string[] =
      (this.selectedHashtagMediaTypes && this.selectedHashtagMediaTypes.length)
        ? this.selectedHashtagMediaTypes
        : [];

    this.media = (this.rawMedia || []).filter((item: any) => {
      const passType = types.length === 0 || types.includes(item.type);
      const passDesc = this.matchesText(item);
      return passType && passDesc;
    });
  }

  onHashtagChange(val: string) {
    this.hashtag = val;
  }

  onTargetChannelChange(val: string) {
    this.targetChannel = val;
  }

  // Busca de mídias próprias
  loadUserMedia(reset = false) {
    if (!this.selectedGoogleAccountId || !this.selectedChannelId) return;

    if (reset) {
      this.userMediaNextPageToken = null;
      this.rawMedia = [];
      this.media = [];
    }

    const mediaTypes = this.selectedMediaTypes && this.selectedMediaTypes.length
      ? this.selectedMediaTypes
      : [];
    this.showDta = true;
    this.LoadSearching = true;
    this.google.getYoutubeChannelUploads(
      this.selectedGoogleAccountId,
      this.selectedChannelId,
      mediaTypes,
      this.userMediaNextPageToken ?? undefined
    ).subscribe({
      next: (res) => {
        const mapped = (res.items || []).map((item: any) => {
          const snippet = item.snippet || {};
          const id = snippet.resourceId?.videoId || (typeof item.id === 'string' ? item.id : '');
          const details = item.details || {};
          const thumb =
            snippet.thumbnails?.maxres?.url ||
            snippet.thumbnails?.standard?.url ||
            snippet.thumbnails?.high?.url ||
            snippet.thumbnails?.medium?.url ||
            snippet.thumbnails?.default?.url ||
            '';

          let embedHtml = '';
          let safeEmbedHtml: SafeHtml | null = null;
          if (details.player && details.player.embedHtml) {
            embedHtml = details.player.embedHtml;
            // 'this.sanitizer' precisa ser o DomSanitizer injetado no construtor
            safeEmbedHtml = this.sanitizer.bypassSecurityTrustHtml(embedHtml);
          }

          const videoId = id || '';
          const embedUrl = videoId
            ? this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${videoId}`)
            : null;

          const selectedAccount = this.googleAccountsOptions.find(
            (a: any) => a.value === this.selectedGoogleAccountId
          );
          const selectedEmail = selectedAccount?.email || null;

          return {
            id: id || '',
            title: snippet.title || '',
            description: snippet.description || '',
            thumbnail: thumb,
            publishedAt: snippet.publishedAt || snippet.publishTime || '',
            link: id ? `https://www.youtube.com/watch?v=${id}` : '',
            type: item.type || 'video',
            duration: item.durationSeconds ?? 0,
            statistics: details.statistics || {},
            embedHtml: embedHtml,
            safeEmbedHtml: safeEmbedHtml,
            safe_player_url: embedUrl,
            channelTitle: snippet.channelTitle || null,
            channelId: snippet.channelId || null,
            email: selectedEmail || null,
          };
        });

        if (reset) {
          this.rawMedia = mapped;
        } else {
          this.rawMedia = [...(this.rawMedia || []), ...mapped];
        }
        // Sempre filtra após atualizar rawMedia
        this.applyUserMediaFilter();
        this.mediaResults.emit(this.media);

        // **Mensagem se vazio**
        if (this.media.length === 0) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Nenhum conteúdo encontrado',
            detail: 'Não encontramos mídias com os filtros atuais. Tente outros critérios!'
          });
        }
        this.extractedByUrl = false;
        this.LoadSearching = false;
        this.userMediaNextPageToken = res.nextPageToken || null;
        this.hasMoreMedia = !!this.userMediaNextPageToken;
      },
      error: () => {
        this.LoadSearching = false;
        this.media = [];
        this.hasMoreMedia = false;

        this.mediaResults.emit([]);
      }
    });
  }



  public hashtagNextPageToken: string | null = null;
  public channelNextPageToken: string | null = null;
  public userMediaNextPageToken: string | null = null;
  public likedNextPageToken: string | null = null;
  // Busca por hashtag


  loadHashtagMedia(reset = false) {
    if (!this.selectedGoogleAccountId || !this.hashtag) return;

    if (reset) {
      this.hashtagNextPageToken = null;
      this.rawMedia = [];
      this.media = [];
    }

    // Sempre busca todos os tipos!
    const mediaTypes = this.selectedHashtagMediaTypes && this.selectedHashtagMediaTypes.length
      ? this.selectedHashtagMediaTypes
      : [];
    this.showDta = true;
    this.LoadSearching = true;
    this.google.searchYoutubeByHashtag(
      this.selectedGoogleAccountId,
      this.hashtag,
      mediaTypes,
      this.hashtagNextPageToken ?? undefined
    ).subscribe({
      next: (res) => {

        const mapped = (res.items || []).map((item: any) => {
          const snippet = item.snippet || {};
          const id = item.id?.videoId || (typeof item.id === 'string' ? item.id : '');
          const details = item.details || {};
          const thumb =
            snippet.thumbnails?.maxres?.url ||
            snippet.thumbnails?.standard?.url ||
            snippet.thumbnails?.high?.url ||
            snippet.thumbnails?.medium?.url ||
            snippet.thumbnails?.default?.url ||
            '';

          let embedHtml = '';
          let safeEmbedHtml: SafeHtml | null = null;
          if (details.player && details.player.embedHtml) {
            embedHtml = details.player.embedHtml;
            // 'this.sanitizer' precisa ser o DomSanitizer injetado no construtor
            safeEmbedHtml = this.sanitizer.bypassSecurityTrustHtml(embedHtml);
          }

          const videoId = id || '';
          const embedUrl = videoId
            ? this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${videoId}`)
            : null;

          const selectedAccount = this.googleAccountsOptions.find(
            (a: any) => a.value === this.selectedGoogleAccountId
          );
          const selectedEmail = selectedAccount?.email || null;

          return {
            id: id || '',
            title: snippet.title || '',
            description: snippet.description || '',
            thumbnail: thumb,
            publishedAt: snippet.publishedAt || snippet.publishTime || '',
            link: id ? `https://www.youtube.com/watch?v=${id}` : '',
            type: item.type || 'video',
            duration: item.durationSeconds ?? 0,
            statistics: details.statistics || {},
            embedHtml: embedHtml,
            safeEmbedHtml: safeEmbedHtml,
            safe_player_url: embedUrl,
            channelTitle: snippet.channelTitle || null,
            channelId: snippet.channelId || null,
            email: selectedEmail || null,
          };
        });

        if (reset) {
          this.rawMedia = mapped;
        } else {
          // SSAPP-8: dedup por id — sem isso, um vídeo que já apareceu numa página
          // anterior podia ser duplicado na lista acumulada (mesmo padrão que
          // InstagramGalleryComponent já resolve via mergeUniqueItems). Item sem id
          // nunca é tratado como duplicata.
          const seenIds = new Set((this.rawMedia || []).map((item: any) => item.id).filter((id: string) => !!id));
          const uniqueIncoming = mapped.filter((item: any) => !item.id || !seenIds.has(item.id));
          this.rawMedia = [...(this.rawMedia || []), ...uniqueIncoming];
        }

        // >>>> Sempre filtra após atualizar rawMedia <<<<
        this.applyHashtagFilter();
        this.mediaResults.emit(this.media);

        // **Mensagem se vazio**
        if (this.media.length === 0) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Nenhum conteúdo encontrado',
            detail: 'Não encontramos mídias com os filtros atuais. Tente outros critérios!'
          });
        }
        this.extractedByUrl = false;
        this.LoadSearching = false;
        this.hashtagNextPageToken = res.nextPageToken || null;
        this.hasMoreMedia = !!this.hashtagNextPageToken;
      },
      error: () => {
        this.LoadSearching = false;
        this.media = [];
        this.hasMoreMedia = false;

        this.mediaResults.emit([]);
      }
    });
  }


  loadingSearch: boolean = false;
  // Busca por canal  
  loadChannelMedia(reset = false) {
    if (!this.selectedGoogleAccountId || !this.targetChannel) return;

    if (reset) {
      this.channelNextPageToken = null;
      this.rawMedia = [];
      this.media = [];
    }

    const mediaTypes = this.getActiveMediaTypesModel && this.getActiveMediaTypesModel.length
      ? this.getActiveMediaTypesModel
      : [];
    this.showDta = true;
    this.loadingSearch = true;
    this.google.getYoutubeChannelVideos(
      this.selectedGoogleAccountId,
      this.targetChannel,
      mediaTypes,
      this.channelNextPageToken ?? undefined
    ).subscribe({
      next: (res) => {
        const mapped = (res.items || []).map((item: any) => {
          const snippet = item.snippet || {};
          const id = item.id?.videoId || (typeof item.id === 'string' ? item.id : '');
          const details = item.details || {};
          const thumb =
            snippet.thumbnails?.maxres?.url ||
            snippet.thumbnails?.standard?.url ||
            snippet.thumbnails?.high?.url ||
            snippet.thumbnails?.medium?.url ||
            snippet.thumbnails?.default?.url ||
            '';

          let embedHtml = '';
          let safeEmbedHtml: SafeHtml | null = null;
          if (details.player && details.player.embedHtml) {
            embedHtml = details.player.embedHtml;
            // 'this.sanitizer' precisa ser o DomSanitizer injetado no construtor
            safeEmbedHtml = this.sanitizer.bypassSecurityTrustHtml(embedHtml);
          }

          const videoId = id || '';
          const embedUrl = videoId
            ? this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${videoId}`)
            : null;

          const selectedAccount = this.googleAccountsOptions.find(
            (a: any) => a.value === this.selectedGoogleAccountId
          );
          const selectedEmail = selectedAccount?.email || null;

          return {
            id: id || '',
            title: snippet.title || '',
            description: snippet.description || '',
            thumbnail: thumb,
            publishedAt: snippet.publishedAt || snippet.publishTime || '',
            link: id ? `https://www.youtube.com/watch?v=${id}` : '',
            type: item.type || 'video',
            duration: item.durationSeconds ?? 0,
            statistics: details.statistics || {},
            embedHtml: embedHtml,
            safeEmbedHtml: safeEmbedHtml,
            safe_player_url: embedUrl,
            channelTitle: snippet.channelTitle || null,
            channelId: snippet.channelId || null,
            email: selectedEmail || null,
          };
        });

        if (reset) {
          this.rawMedia = mapped;
        } else {
          this.rawMedia = [...(this.rawMedia || []), ...mapped];
        }
        // Sempre filtra após atualizar rawMedia
        this.applyUserMediaFilter();
        this.mediaResults.emit(this.media);

        // **Mensagem se vazio**
        if (this.media.length === 0) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Nenhum conteúdo encontrado',
            detail: 'Não encontramos mídias com os filtros atuais. Tente outros critérios!'
          });
        }
        this.extractedByUrl = false;
        this.loadingSearch = false;
        this.channelNextPageToken = res.nextPageToken || null;
        this.hasMoreMedia = !!this.channelNextPageToken;
      },
      error: (error) => {
        this.loadingSearch = false;
        this.media = [];
        this.hasMoreMedia = false;
        // Mensagem amigável do backend ou fallback
        const msg = error?.error?.message || 'Erro ao buscar conteúdo no canal do YouTube.';

        this.errorHandler.handle(error, msg);
        this.mediaResults.emit([]);
      }
    });
  }

  @Output() openPostDialog = new EventEmitter<any>();
  openDialog(item: any) {
    // Se necessário, formate o item aqui!
    this.openPostDialog.emit(this.formatDialogItem(item));
  }
  formatDialogItem(item: any): any {
    // No TikTok já faz o "safe_player_url", etc
    // No Google, vamos montar algo padrão:
    return {
      ...item,
      source: 'youtube',
      media_type: 'VIDEO',
      media_url: item.link || `https://www.youtube.com/watch?v=${item.id}`,
      thumbnail_url: item.thumbnail,
      caption: item.description || item.title,
      timestamp: item.publishedAt,
      permalink: item.link || `https://www.youtube.com/watch?v=${item.id}`,
      // player embed (para exibir vídeo no dialog)
      safe_player_url: item.id
        ? this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${item.id}`)
        : null
    };
  }


  public loadMoreMedia(): void {
    if (this.activeTab.label === 'Hashtag') {
      this.loadHashtagMedia(false);
    } else if (this.activeTab.label === 'Mídias') {
      this.loadUserMedia(false); // Implemente a paginação depois
    } else if (this.activeTab.label === 'Canal') {
      this.loadChannelMedia(false); // Implemente se precisar
    } else if (this.activeTab.label === 'Curtidos') {
      this.loadLikedMedia(false); // Implemente se precisar
    }
  }

  LoadSearching = false;
  loadLikedMedia(reset = false) {
    if (!this.selectedGoogleAccountId || !this.selectedChannelId) return;

    if (reset) {
      this.likedNextPageToken = null;
      this.rawMedia = [];
      this.media = [];
    }

    const mediaTypes = this.getActiveMediaTypesModel && this.getActiveMediaTypesModel.length
      ? this.getActiveMediaTypesModel
      : [];
    this.LoadSearching = true;
    this.showDta = true;
    this.google.getYoutubeLikedVideos(
      this.selectedGoogleAccountId,
      this.selectedChannelId,
      mediaTypes,
      this.likedNextPageToken ?? undefined
    ).subscribe({
      next: (res) => {
        const mapped = (res.items || []).map((item: any) => {
          const snippet = item.snippet || {};
          const id = item.id || '';
          const details = item.details || {};
          const thumb =
            snippet.thumbnails?.maxres?.url ||
            snippet.thumbnails?.standard?.url ||
            snippet.thumbnails?.high?.url ||
            snippet.thumbnails?.medium?.url ||
            snippet.thumbnails?.default?.url ||
            '';

          let embedHtml = '';
          let safeEmbedHtml: SafeHtml | null = null;
          if (details.player && details.player.embedHtml) {
            embedHtml = details.player.embedHtml;
            // 'this.sanitizer' precisa ser o DomSanitizer injetado no construtor
            safeEmbedHtml = this.sanitizer.bypassSecurityTrustHtml(embedHtml);
          }

          const videoId = id || '';
          const embedUrl = videoId
            ? this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${videoId}`)
            : null;

          const selectedAccount = this.googleAccountsOptions.find(
            (a: any) => a.value === this.selectedGoogleAccountId
          );
          const selectedEmail = selectedAccount?.email || null;

          return {
            id: id || '',
            title: snippet.title || '',
            description: snippet.description || '',
            thumbnail: thumb,
            publishedAt: snippet.publishedAt || snippet.publishTime || '',
            link: id ? `https://www.youtube.com/watch?v=${id}` : '',
            type: item.type || 'video',
            duration: item.durationSeconds ?? 0,
            statistics: details.statistics || {},
            embedHtml: embedHtml,
            safeEmbedHtml: safeEmbedHtml,
            safe_player_url: embedUrl,
            channelTitle: snippet.channelTitle || null,
            channelId: snippet.channelId || null,
            email: selectedEmail || null,
          };
        });

        if (reset) {
          this.rawMedia = mapped;
        } else {
          this.rawMedia = [...(this.rawMedia || []), ...mapped];
        }
        this.applyUserMediaFilter();
        this.mediaResults.emit(this.media);

        // **Mensagem se vazio**
        if (this.media.length === 0) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Nenhum conteúdo encontrado',
            detail: 'Não encontramos mídias com os filtros atuais. Tente outros critérios!'
          });
        }

        this.LoadSearching = false;
        this.extractedByUrl = false;
        this.likedNextPageToken = res.nextPageToken || null;
        this.hasMoreMedia = !!this.likedNextPageToken;
      },
      error: () => {
        this.LoadSearching = false;
        this.media = [];
        this.hasMoreMedia = false;

        this.mediaResults.emit([]);
      }
    });
  }

  public selectedChannelMediaTypes: string[] = [];


  get getActiveMediaTypesModel() {
    if (this.activeTab.label === 'Hashtag') return this.selectedHashtagMediaTypes;
    if (this.activeTab.label === 'Canal') return this.selectedChannelMediaTypes;
    return this.selectedMediaTypes; // por padrão, usa de mídias
  }
  set getActiveMediaTypesModel(val: string[]) {
    if (this.activeTab.label === 'Hashtag') this.selectedHashtagMediaTypes = val;
    else if (this.activeTab.label === 'Canal') this.selectedChannelMediaTypes = val;
    else this.selectedMediaTypes = val;
  }








  // estado das seções
  collapsed: { ytMain: boolean; ytExtract: boolean } = {
    ytMain: true,   // fechada
    ytExtract: true  // fechada
  };

  toggle(section: 'ytMain' | 'ytExtract'): void {
    this.collapsed[section] = !this.collapsed[section];
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['isFeed']) {
      this.updateCollapsed();
    }
  }

  updateCollapsed() {
    this.collapsed.ytMain = this.isFeed ? false : true;
    this.collapsed.ytExtract = true;
  }
  ///// extrair

  // estado
  youtubeUrl = '';
  extracting: boolean = false;
  private getStoreNameFromStorage(): string | null {
    try {
      const direct = localStorage.getItem('store_name');
      if (direct) return direct;

      // fallback: alguns ambientes salvam no store_data
      const sd = localStorage.getItem('store_data');
      if (sd) {
        const obj = JSON.parse(sd);
        return obj?.store_name ?? null;
      }
    } catch { }
    return null;
  }

  parseIsoDuration(iso: string): number {
    if (!iso) return 0;
    const match = iso.match(/^PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?$/);
    if (!match) return 0;
    const [, h, m, s] = match;
    return (parseInt(h || '0', 10) * 3600) + (parseInt(m || '0', 10) * 60) + (parseInt(s || '0', 10));
  }

  // (opcional) centralize o mapeamento num método único para usar em hashtag/URL
  private mapYoutubeItemsToMedia(items: any[]): any[] {
    return (items || []).map((item: any) => {
      const snippet = item.snippet || {};
      const id = item.id?.videoId || (typeof item.id === 'string' ? item.id : '');
      const details = item.details || {};
      const thumb =
        snippet.thumbnails?.maxres?.url ||
        snippet.thumbnails?.standard?.url ||
        snippet.thumbnails?.high?.url ||
        snippet.thumbnails?.medium?.url ||
        snippet.thumbnails?.default?.url ||
        '';

      let embedHtml = '';
      let safeEmbedHtml: SafeHtml | null = null;
      if (details.player && details.player.embedHtml) {
        embedHtml = details.player.embedHtml;
        safeEmbedHtml = this.sanitizer.bypassSecurityTrustHtml(embedHtml);
      }

      const videoId = id || '';
      const embedUrl = videoId
        ? this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${videoId}`)
        : null;

      const selectedAccount = this.googleAccountsOptions.find(
        (a: any) => a.value === this.selectedGoogleAccountId
      );
      const selectedEmail = selectedAccount?.email || null;

      const storeName = this.getStoreNameFromStorage();

      let duration = 0;
      if (typeof item.durationSeconds === 'number') {
        duration = item.durationSeconds;
      } else if (details?.contentDetails?.duration) {
        duration = this.parseIsoDuration(details.contentDetails.duration);
      } else if (typeof item.duration === 'string') {
        duration = this.parseIsoDuration(item.duration);
      }

      return {
        id: id || '',
        title: snippet.title || '',
        description: snippet.description || '',
        thumbnail: thumb,
        publishedAt: snippet.publishedAt || snippet.publishTime || '',
        link: id ? `https://www.youtube.com/watch?v=${id}` : '',
        type: item.type || 'video',
        duration: duration,
        statistics: details.statistics || {},
        embedHtml: embedHtml,
        safeEmbedHtml: safeEmbedHtml,
        safe_player_url: embedUrl,
        channelTitle: snippet.channelTitle || null,
        channelId: snippet.channelId || null,
        email: snippet.channelHandle ?? selectedEmail ?? storeName ?? null,
      };
    });
  }
  extractedByUrl: boolean = false;
  // extrair por URL
  extract(reset = false) {
    if (!this.youtubeUrl) return;

    if (reset) {
      this.rawMedia = [];
      this.media = [];
      this.hasMoreMedia = false;
    }

    this.showDta = true;
    this.extracting = true;

    this.google.extractYoutubeByUrlPublic(
      this.youtubeUrl,
      10 // maxResults (para playlist/canal)
    ).subscribe({
      next: (res) => {
        const mapped = this.mapYoutubeItemsToMedia(res.items || []);
        this.rawMedia = mapped;
        this.applyHashtagFilter();        // reaproveitando sua filtragem
        this.mediaResults.emit(this.media);

        if (!this.media?.length) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Nada encontrado',
            detail: 'Não foi possível extrair conteúdo dessa URL.'
          });
        }
        this.extracting = false;
        this.extractedByUrl = true;
      },
      error: (error) => {
        this.extracting = false;
        this.media = [];
        this.mediaResults.emit([]);
        this.errorHandler.handle(error, 'Falha ao extrair o vídeo do YouTube.');
      }
    });
  }

  ///// extrair

  // filtro
  // estado do filtro
  descriptionFilter: string = '';

  // normalização simples para busca case/acento-insensitive
  private normalize(s: string): string {
    return (s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '');
  }

  // Busca em título + descrição (+ tags). Mantém AND entre palavras.
  private matchesText(item: any): boolean {
    const q = this.normalize(this.descriptionFilter?.trim());
    if (!q) return true;

    // 🔹 Monte o “haystack” com título + descrição (+ tags se existirem)
    const tags = Array.isArray(item?.tags) ? item.tags.join(' ') : '';
    const hay = this.normalize(`${item?.title || ''} ${item?.description || ''} ${tags}`);

    // AND por tokens; considera também hashtag (#token)
    const tokens = q.split(/\s+/).filter(Boolean);
    return tokens.every(tok => hay.includes(tok) || hay.includes(`#${tok}`));
  }

  onFiltersChanged() {
    // Reaplica o filtro no dataset atual, qualquer que seja a origem
    // (hashtag, user uploads, canal, liked) — observe que nos seus loads:
    // - hashtag chama applyHashtagFilter()
    // - os demais chamam applyUserMediaFilter()
    // então aqui basta chamar a que você já usa nessas telas/abas.
    if (this.activeTab.label === 'hashtag') {        // se você tiver essa flag
      this.applyHashtagFilter();
    } else {
      this.applyUserMediaFilter();
    }
    this.mediaResults.emit(this.media);
    //this.cdr?.markForCheck?.();
  }

  clearDescriptionFilter() {
    this.descriptionFilter = '';
    this.onFiltersChanged();
  }

  youtubeInvalid: boolean = false;
  youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|shorts\/)|youtu\.be\/)[\w\-]{11}(&\S*)?$/i;

  checkYoutubeUrl() {
    // Só marca como inválida se não estiver vazia (evita erro ao digitar e apagar tudo)
    this.youtubeInvalid = !!this.youtubeUrl && !this.youtubeRegex.test(this.youtubeUrl.trim());
  }

  playlistsOptions: Array<{ label: string; value: string; itemCount: number | null; thumbnail?: string }> = [];
  selectedPlaylist: string | null = null;
  playlistNextPageToken: string | null = null;
  hasMorePlaylists = false;
  loadingPlaylists = false;

  loadChannelPlaylistsForSelect(reset = false) {
    if (this.privatePlaylists) {
      if (!this.selectedGoogleAccountId) {
        this.messageService.add({ severity: 'warn', summary: 'Conta necessária', detail: 'Selecione a conta Google.' });
        return;
      }
      if (!this.selectedChannelId) {
        this.messageService.add({ severity: 'warn', summary: 'Canal necessário', detail: 'Selecione o canal do YouTube.' });
        return;
      }
      // PRIVADAS: precisa de conta + canal selecionado
      if (!this.selectedGoogleAccountId || !this.selectedChannelId) return;

      if (reset) {
        this.playlistsOptions = [];
        this.playlistNextPageToken = null;
        this.hasMorePlaylists = false;
      }

      this.loadingPlaylists = true;
      this.google.getYoutubeMyPlaylists(
        this.selectedGoogleAccountId,
        this.playlistNextPageToken ?? undefined,
        20 // maxResults
      ).subscribe({
        next: (res) => {
          // Filtra pelo canal selecionado (multi-channel accounts)
          const filtered = (res.items || []).filter((it: any) =>
            (it?.snippet?.channelId || '') === this.selectedChannelId
          );

          const mapped = filtered.map((it: any) => {
            const sn = it.snippet || {};
            const th = sn.thumbnails || {};
            return {
              label: sn.title || '(sem título)',
              value: it.id || '',
              itemCount: (it.contentDetails && typeof it.contentDetails.itemCount === 'number') ? it.contentDetails.itemCount : null,
              thumbnail: th.high?.url || th.medium?.url || th.default?.url || ''
            };
          }).filter((o: any) => !!o.value);

          this.playlistsOptions = reset ? mapped : [...this.playlistsOptions, ...mapped];
          this.playlistNextPageToken = res.nextPageToken || null;
          this.hasMorePlaylists = !!this.playlistNextPageToken;

          if (!this.playlistsOptions.length) {
            this.messageService.add({ severity: 'warn', summary: 'Nenhuma playlist', detail: 'Nenhuma playlist privada/pública encontrada neste canal.' });
          }
          this.loadingPlaylists = false;
        },
        error: (error) => {
          this.loadingPlaylists = false;
          this.errorHandler.handle(error, 'Falha ao listar playlists privadas.');
        }
      });

      return;
    }

    // PÚBLICAS (fluxo existente)
    if (!this.selectedGoogleAccountId || !this.targetChannel) return;

    if (reset) {
      this.playlistsOptions = [];
      this.playlistNextPageToken = null;
      this.hasMorePlaylists = false;
    }

    this.loadingPlaylists = true;
    this.google.getYoutubeChannelPlaylists(
      this.selectedGoogleAccountId,
      this.targetChannel,
      this.playlistNextPageToken ?? undefined,
      20
    ).subscribe({
      next: (res) => {
        const mapped = (res.items || []).map((it: any) => {
          const sn = it.snippet || {};
          const th = sn.thumbnails || {};
          return {
            label: sn.title || '(sem título)',
            value: it.id || '',
            itemCount: (it.contentDetails && typeof it.contentDetails.itemCount === 'number') ? it.contentDetails.itemCount : null,
            thumbnail: th.high?.url || th.medium?.url || th.default?.url || ''
          };
        }).filter((o: any) => !!o.value);

        this.playlistsOptions = reset ? mapped : [...this.playlistsOptions, ...mapped];
        this.playlistNextPageToken = res.nextPageToken || null;
        this.hasMorePlaylists = !!this.playlistNextPageToken;

        if (!this.playlistsOptions.length) {
          this.messageService.add({ severity: 'warn', summary: 'Nenhuma playlist', detail: 'Esse canal não possui playlists públicas.' });
        }
        this.loadingPlaylists = false;
      },
      error: (error) => {
        this.loadingPlaylists = false;
        this.errorHandler.handle(error, 'Falha ao listar playlists.');
      }
    });
  }


  // quando o usuário seleciona playlists no MultiSelect
  onPlaylistsChange(ev: any) {
    const id = this.selectedPlaylist;
    if (!id) {
      this.rawMedia = [];
      this.media = [];
      this.mediaResults.emit([]);
      return;
    }

    if (!this.isFeed) {
      // Agora só uma playlist:
      this.loadVideosFromMultiplePlaylists([id], true);
    }
  }


  // carrega vídeos de N playlists (mescla)
  private loadVideosFromMultiplePlaylists(playlistIds: string[], reset = false) {
    if (!this.selectedGoogleAccountId) return;

    if (reset) {
      this.rawMedia = [];
      this.media = [];
    }

    const mediaTypes = this.getActiveMediaTypesModel?.length ? this.getActiveMediaTypesModel : [];
    this.loadingSearch = true;

    // dispara em sequência para manter ordem; se preferir, use forkJoin + sort por publishedAt
    const seq = playlistIds.reduce((acc, pid: string) => acc.pipe(
      switchMap(() => this.google.getYoutubePlaylistItems(
        this.selectedGoogleAccountId!,
        pid || '',
        mediaTypes,
        undefined,
        10
      ))
    ), of({ items: [] as any[] } as any));

    seq.subscribe({
      next: (res) => {
        const items = res.items || [];
        const mapped = items.map((item: any) => {
          const sn = item.snippet || {};
          const id = sn.resourceId?.videoId || (typeof item.id === 'string' ? item.id : '');
          const details = item.details || {};
          const th = sn.thumbnails || {};
          const thumb = th.maxres?.url || th.standard?.url || th.high?.url || th.medium?.url || th.default?.url || '';
          const embedHtml = details.player?.embedHtml || '';
          const safeEmbedHtml = embedHtml ? this.sanitizer.bypassSecurityTrustHtml(embedHtml) : null;
          const embedUrl = id ? this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${id}`) : null;

          const selectedAccount = this.googleAccountsOptions.find((a: any) => a.value === this.selectedGoogleAccountId);
          const selectedEmail = selectedAccount?.email || null;

          return {
            id: id || '',
            title: sn.title || '',
            description: sn.description || '',
            thumbnail: thumb,
            publishedAt: sn.publishedAt || sn.publishTime || '',
            link: id ? `https://www.youtube.com/watch?v=${id}` : '',
            type: item.type || 'video',
            duration: item.durationSeconds ?? 0,
            statistics: details.statistics || {},
            embedHtml,
            safeEmbedHtml,
            safe_player_url: embedUrl,
            channelTitle: sn.channelTitle || null,
            channelId: sn.channelId || null,
            email: selectedEmail || null,
          };
        });

        // mescla + aplica filtros
        this.rawMedia = [...(this.rawMedia || []), ...mapped];
        this.applyUserMediaFilter();
        this.mediaResults.emit(this.media);
        this.showDta = true;
      },
      error: (error) => {
        this.loadingSearch = false;
        this.errorHandler.handle(error, 'Falha ao carregar vídeos das playlists selecionadas.');
      },
      complete: () => {
        this.loadingSearch = false;
        if (!this.media?.length) {
          this.messageService.add({ severity: 'warn', summary: 'Sem conteúdo', detail: 'Nenhum vídeo nas playlists selecionadas (ou filtrado).' });
        }
      }
    });
  }

  // No GoogleGalleryComponent
  public loadVideosForSelectedPlaylist(): Observable<any[]> {
    const playlistId = this.selectedPlaylist;
    if (!playlistId) return of([]);
    return this.google.getYoutubePlaylistItems(
      this.selectedGoogleAccountId!,
      playlistId,
      this.getActiveMediaTypesModel ?? [],
      undefined,
      10 // limite de vídeos por playlist
    ).pipe(
      map(res => (res.items || []).map((item: any) => {
        const sn = item.snippet || {};
        const id = sn.resourceId?.videoId || item.contentDetails?.videoId || item.id || '';
        const details = item.details || {};
        const th = sn.thumbnails || {};
        const thumb =
          th.maxres?.url ||
          th.standard?.url ||
          th.high?.url ||
          th.medium?.url ||
          th.default?.url ||
          '';

        return {
          id: id || '',
          title: sn.title || '',
          description: sn.description || '',
          thumbnail: thumb,
          publishedAt: sn.publishedAt || sn.publishTime || '',
          link: id ? `https://www.youtube.com/watch?v=${id}` : '',
          type: item.type || 'video',
          duration: item.durationSeconds ?? 0,
          statistics: details.statistics || {},
          channelTitle: sn.channelTitle || details.snippet?.channelTitle || null,
          channelId: sn.channelId || details.snippet?.channelId || null,
          email: null,
        };
      }))
    );
  }

  public privatePlaylists = false;

  onPrivateToggle(on: boolean) {
    this.privatePlaylists = on;
  
    // zerar UI de playlists ao alternar
    this.playlistsOptions = [];
    this.selectedPlaylist = null;
    this.playlistNextPageToken = null;
    this.hasMorePlaylists = false;
  
    // 🔸 NÃO altere showConectAccount aqui
    // Se ligou "privadas" e há contas mas nenhuma selecionada, apenas avisa:
    if (on) {
      if (!this.googleAccountsOptions?.length) {
        // Sem contas conectadas — o loadGoogleAccounts() já cuida de setar showConectAccount = true
        // então aqui não precisa fazer nada
        return;
      }
      if (!this.selectedGoogleAccountId) {
        this.messageService.add({
          severity: 'info',
          summary: 'Selecione uma conta',
          detail: 'Escolha a conta Google e o canal para listar suas playlists (inclui privadas).'
        });
      }
    }
  }

}
